import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function DigitalMarketingPage() {
    pageTitle('Digital Marketing Services');
    const params = useParams();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <PageHeading
                title='Digital Marketing Services'
                bgSrc='/images/service_hero_bg.jpeg'
                pageLinkText={params.serviceDetailsId || 'Digital Marketing'}
            />
            <Spacing lg='145' md='80'/>
            <Div className="container">
                <SectionHeading
                    title='Marketing Working Process'
                    subtitle='Digital Marketing'
                    variant='cs-style1 text-center'
                />
                <Spacing lg='90' md='45'/>
                <Div className="row">
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_1.svg'
                            title='Research & Strategy'
                            subtitle='We begin with comprehensive market research to understand your industry landscape, competitive positioning, and target audience behaviors. Based on these insights, we develop tailored marketing strategies aligned with your business goals.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_2.svg'
                            title='Campaign Development'
                            subtitle='Our team creates compelling, multi-channel marketing campaigns designed to engage your audience at every stage of the customer journey. We craft persuasive content, design eye-catching creatives, and implement advanced targeting parameters.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_3.svg'
                            title='Analysis & Optimization'
                            subtitle='We continuously monitor campaign performance through sophisticated analytics tools, providing transparent reporting on key metrics. This data-driven approach allows us to identify optimization opportunities and adjust strategies in real-time.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='120' md='50'/>
            <Div className="container">
                <Div className="row">
                    <Div className="col-lg-6">
                        <h2 className="cs-font_30 cs-m0">Grow your digital presence</h2>
                        <Spacing lg='30' md='30'/>
                        <p>At ACE Cloud Solution, we drive measurable business growth through strategic digital marketing campaigns that connect you with your target audience. Our data-driven approach ensures maximum ROI across all digital channels.</p>
                        <p>We create comprehensive marketing strategies that amplify your brand's voice, attract qualified leads, and convert prospects into loyal customers. Through precise targeting and continuous optimization, we deliver campaigns that generate real business results.</p>
                        <Spacing lg='30' md='30'/>
                        <h3 className="cs-font_22 cs-m0">Key benefits of our marketing approach:</h3>
                        <Spacing lg='15' md='15'/>
                        <ul className="cs-list cs-style1">
                            <li>Data-driven strategies based on audience insights</li>
                            <li>Multi-channel campaigns for comprehensive reach</li>
                            <li>Performance tracking with transparent reporting</li>
                            <li>Continuous optimization for maximum ROI</li>
                            <li>Scalable approaches that grow with your business</li>
                        </ul>
                    </Div>
                    <Div className="col-lg-5 offset-lg-1">
                        <Div className="cs-image_layer cs-style1">
                            <Div className="cs-image_layer_in">
                                <img src="/images/service_3.jpeg" alt="Digital Marketing" className="w-100" />
                            </Div>
                        </Div>
                        <Spacing lg='0' md='40'/>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='100' md='80'/>
            <Div className="container">
                <Div className="row align-items-center">
                    <Div className="col-xl-5 col-lg-6">
                        <Div className="cs-radius_15 cs-shine_hover_1">
                            <img src="/images/service_img_1.jpeg" alt="Service" className='cs-radius_15 w-100' />
                        </Div>
                        <Spacing lg='0' md='40'/>
                    </Div>
                    <Div className="col-lg-6 offset-xl-1">
                        <h2 className="cs-font_50 cs-m0">Below our most marketing related services</h2>
                        <Spacing lg='50' md='30'/>
                        <Div className="row">
                            <Div className="col-lg-6">
                                <Button btnLink='' btnText='Search engine optimization' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Pay-per-click advertising' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Social media marketing' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Content marketing' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Email marketing' variant='cs-type2'/>
                                <Spacing lg='0' md='10'/>
                            </Div>
                            <Div className="col-lg-6">
                                <Button btnLink='' btnText='Conversion optimization' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Digital strategy' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Analytics and reporting' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Marketing automation' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Reputation management' variant='cs-type2'/>
                                <Spacing lg='0' md='10'/>
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80'/>
            {/*<TestimonialSlider />*/}
            <Spacing lg='145' md='80'/>
            <Div className="container cs-shape_wrap_4">
                <Div className="cs-shape_4"></Div>
                <Div className="cs-shape_4"></Div>
                <Div className="container">
                    <Div className="row">
                        <Div className="col-xl-5 col-lg-6">
                            <SectionHeading
                                title='Some pre questions and answers'
                                subtitle="FAQ's"
              />
              <Spacing lg='90' md='45'/>
                        </Div>
                        <Div className="col-lg-6 offset-xl-1">
                            <Accordion/>
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80'/>
            <Div className="container">
                <Cta
                    title="Let's grow your <br />business <i>together</i>"
                    btnText='Schedule a Consultation'
                    btnLink='/contact'
                    bgSrc='/images/cta_bg.jpeg'
                    />
            </Div>
        </>
    )
}